import { render, staticRenderFns } from "./ClassSearch.vue?vue&type=template&id=192f8965&scoped=true&"
import script from "./classsearch.js?vue&type=script&lang=js&"
export * from "./classsearch.js?vue&type=script&lang=js&"
import style0 from "./ClassSearch.vue?vue&type=style&index=0&id=192f8965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f8965",
  null
  
)

export default component.exports